export const MOBILE_MAX_ALERTS_ICONS = 4
